import React from 'react';
import { Palette, Type, Image, Sparkles } from 'lucide-react';

export default function BrandingGuide() {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Brand Colors */}
        <div className="space-y-4">
          <h3 className="font-semibold text-gray-900 flex items-center">
            <Palette className="w-5 h-5 text-blue-500 mr-2" />
            Brand Colors
          </h3>
          <div className="grid grid-cols-2 gap-2">
            <div className="space-y-2">
              <div className="h-12 rounded-lg bg-blue-500" />
              <p className="text-sm text-gray-600">Primary Blue</p>
            </div>
            <div className="space-y-2">
              <div className="h-12 rounded-lg bg-indigo-600" />
              <p className="text-sm text-gray-600">Secondary Indigo</p>
            </div>
          </div>
        </div>

        {/* Typography */}
        <div className="space-y-4">
          <h3 className="font-semibold text-gray-900 flex items-center">
            <Type className="w-5 h-5 text-blue-500 mr-2" />
            Typography
          </h3>
          <div className="space-y-2">
            <p className="text-2xl font-bold">Heading Font</p>
            <p className="text-base">Body Font: Inter</p>
          </div>
        </div>
      </div>

      {/* Logo */}
      <div className="border border-blue-100 rounded-lg p-4">
        <h3 className="font-semibold text-gray-900 mb-4 flex items-center">
          <Image className="w-5 h-5 text-blue-500 mr-2" />
          Logo
        </h3>
        <div className="flex items-center space-x-4">
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <div className="flex items-center space-x-2">
              <Sparkles className="w-8 h-8 text-blue-500" />
              <span className="text-xl font-bold gradient-text">Gecko</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}